import { Flex, Grid, Heading, Link, Text } from "@chakra-ui/react";
import React from "react";
import { NotFound } from "src/components/Feedback/NotFound";
import { Breadcrumb } from "src/components/Navigation/Breadcrumb";
import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import { useOrganization } from "src/hooks/useOrganization";
import * as breadcrumb from "src/services/breadcrumb";

const LabsExternalLink: React.FC<{ href: string; label: string }> = ({
  href,
  label,
}) => {
  return (
    <Link
      color={"primary.500"}
      textDecoration="underline"
      href={href}
      isExternal
    >
      {label}
    </Link>
  );
};

export const AboutAvelaLabs: React.FC = () => {
  const organization = useOrganization();

  const flags = useFlags(["avela-labs"]);
  if (!flags["avela-labs"].enabled) {
    return <NotFound />;
  }

  if (!organization.hasData()) return null;
  return (
    <Flex direction="column" gap={6} height="100%">
      <Breadcrumb
        items={breadcrumb.avelaLabs.getBreadcrumbsForAvelaLabs(organization)}
      />
      <Heading as="h1" variant="admin">
        What is Avela Labs?
      </Heading>
      <Text>
        <LabsExternalLink
          href="https://help.avela.org/hc/en-us/articles/41952806442125-What-is-Avela-Labs"
          label="Avela Labs"
        />{" "}
        is where you can try Beta features before anyone else. Your feedback
        will directly shape what these tools become and help create solutions
        that work.
      </Text>
      <Text>
        These Beta features are still growing and might change as we learn from
        you. But that's exactly why your perspective matters. When you share
        what works (and what doesn't), you're helping shape the future.
      </Text>
      <Text>
        Have ideas that aren't here? Submit them{" "}
        <LabsExternalLink
          href="https://help.avela.org/hc/en-us/articles/34640304218381-Ideas"
          label="here"
        />
        .
      </Text>
      <Heading as="h2" variant="admin">
        Try our Beta features
      </Heading>
      <Grid templateColumns="repeat(1, 1fr)" gap={2} width="100%">
        <LabsExternalLink
          href="https://help.avela.org/hc/en-us/articles/41954723417869-Translating-Messages"
          label="Translating messages"
        />
        <LabsExternalLink
          href="https://help.avela.org/hc/en-us/articles/36719796854029-Verifying-forms-with-Avela-Intelligence"
          label="Verifying forms with Avela Intelligence"
        />
        <LabsExternalLink
          href="https://help.avela.org/hc/en-us/articles/47341300235021-Get-started-with-Payments"
          label="Collecting payments in Avela"
        />
        <LabsExternalLink
          href="https://help.avela.org/hc/en-us/articles/48369514343181-Publish-seat-availability-to-families"
          label="Public view of seat availability"
        />
      </Grid>
      <Heading as="h2" variant="admin">
        Labs graduates
      </Heading>
      <Grid templateColumns="repeat(1, 1fr)" gap={2} width="100%">
        <LabsExternalLink
          href="https://help.avela.org/hc/en-us/articles/41955231094285-Student-Profile-Duplicates"
          label="Duplicate student report"
        />
      </Grid>
    </Flex>
  );
};
